import { RuleContext } from '@alfresco/adf-extensions';
import { SharedLink } from '@alfresco/js-api';

import {
  canToggleEditOffline,
  canUpdateSelectedNode,
  isTrashcanItemSelected,
  isUserWriteLockOwner,
  isWriteLocked,
} from '@adw/projects/aca-shared/rules/src/app.rules';
import { isWorkingCopy } from '../../extensions/rules/app.custom-rules';

export function isWordFile(context: RuleContext): boolean {
  return (
    context?.selection?.file?.entry?.content?.mimeTypeName ===
    'Microsoft Word 2007'
  );
}

export function isPowerPointFile(context: RuleContext): boolean {
  return (
    context?.selection?.file?.entry?.content?.mimeTypeName ===
    'Microsoft PowerPoint 2007'
  );
}

export function isExcelFile(context: RuleContext): boolean {
  return (
    context?.selection?.file?.entry?.content?.mimeTypeName ===
    'Microsoft Excel 2007'
  );
}

export function isActiveMicrosoftSession(context: RuleContext): boolean {
  let nodeId = context?.selection?.file?.entry?.id;
  if (context?.selection?.file?.entry instanceof SharedLink) {
    const shared: SharedLink = context.selection.file.entry;
    nodeId = shared?.nodeId;
  }
  return (
    context?.selection?.file?.entry?.properties?.['moo:sessionNodeId'] ===
      nodeId &&
    context?.selection?.file?.entry?.properties?.['moo:acsSessionOwner'] ===
      context?.selection?.file?.entry?.properties?.['cm:lockOwner']?.id
  );
}

export function isMicrosoftOnlinePluginEnabled(): boolean {
  return localStorage?.getItem('msOnlineEditingAllowed') === 'true';
}

export function canEditInMsOnline(context: RuleContext): boolean {
  return (
    isMicrosoftOnlinePluginEnabled() &&
    !isActiveMicrosoftSession(context) &&
    !isWriteLocked(context) &&
    !isTrashcanItemSelected(context) &&
    !isWorkingCopy(context?.selection?.file?.entry) &&
    canUpdateSelectedNode(context)
  );
}

export function canEditOnlineWordFile(context: RuleContext): boolean {
  return isWordFile(context) && canEditInMsOnline(context);
}

export function canEditOnlinePowerPointFile(context: RuleContext): boolean {
  return isPowerPointFile(context) && canEditInMsOnline(context);
}

export function canEditOnlineExcelFile(context: RuleContext): boolean {
  return isExcelFile(context) && canEditInMsOnline(context);
}

export function canResumeOnlineWordFile(context: RuleContext): boolean {
  return isWordFile(context) && canUpdateMicrosoftSession(context);
}

export function canResumeOnlinePowerPointFile(context: RuleContext): boolean {
  return isPowerPointFile(context) && canUpdateMicrosoftSession(context);
}

export function canResumeOnlineExcelFile(context: RuleContext): boolean {
  return isExcelFile(context) && canUpdateMicrosoftSession(context);
}

export function updateToggleEditOffline(context: RuleContext) {
  return !isActiveMicrosoftSession(context) && canToggleEditOffline(context);
}

export function canUpdateMicrosoftSession(context: RuleContext) {
  return (
    isMicrosoftOnlinePluginEnabled() &&
    isActiveMicrosoftSession(context) &&
    isUserWriteLockOwner(context) &&
    !isTrashcanItemSelected(context)
  );
}
